import { Spin } from "antd";
import { CAMPAIGN_TYPE } from "features/Campaign/constants";
import { getQuery } from "utils/helperFuncs";
import CampaignForm from "../Form";
import CashDiscountForm from "../Form/CashDiscountForm";
import useCreateForm from "./useCreateForm";

const CreateForm = () => {
  const GET_QUERY = getQuery();
  const {
    form,
    handleValuesChange,
    isApplyWithPromotion,
    promoType,
    handleCheckIsApplyWithPromo,
    loadingCheckDuplicateCodes,
    dataConfirmModal,
    visibleConfirmModal,
    handleOpenConfirmModal,
    handleCreateCampaign,
    handleCancelConfirmModal,
    createLoading,
    indexErrorCombo,
    initialValues,
  } = useCreateForm();

  const isCashDiscount =
    GET_QUERY.campaignType === CAMPAIGN_TYPE.CASH_DISCOUNT || GET_QUERY.campaignType === "CASH_DISCOUNT";

  return (
    <Spin spinning={loadingCheckDuplicateCodes || createLoading}>
      {isCashDiscount ? (
        <CashDiscountForm
          form={form}
          handleValuesChange={handleValuesChange}
          isApplyWithPromotion={isApplyWithPromotion}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          loadingCheckDuplicateCodes={loadingCheckDuplicateCodes}
          dataConfirmModal={dataConfirmModal}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          handleActionCampaign={handleCreateCampaign}
          createLoading={createLoading}
          dataCampaign={{ promotionCampaignTierGroups: [] }}
          initialValues={initialValues}
        />
      ) : (
        <CampaignForm
          form={form}
          handleValuesChange={handleValuesChange}
          isApplyWithPromotion={isApplyWithPromotion}
          promoType={promoType}
          handleCheckIsApplyWithPromo={handleCheckIsApplyWithPromo}
          loadingCheckDuplicateCodes={loadingCheckDuplicateCodes}
          dataConfirmModal={dataConfirmModal}
          visibleConfirmModal={visibleConfirmModal}
          handleOpenConfirmModal={handleOpenConfirmModal}
          handleCancelConfirmModal={handleCancelConfirmModal}
          handleActionCampaign={handleCreateCampaign}
          createLoading={createLoading}
          indexErrorCombo={indexErrorCombo}
        />
      )}
    </Spin>
  );
};

export default CreateForm;
